import React, { useState } from 'react';
import FileExplorer, { FileNode } from '../FileExplorer';
import CodeEditor from '../CodeEditor';
import { Permissions } from '../../constants';

export interface CodebasePanelProps {
  projectId: string;
  onClose: () => void;
  permissions?: string[];
  initialSelectedFile?: string | null;
  onInitialFileSelected?: () => void;
}

const CodebasePanel: React.FC<CodebasePanelProps> = ({ projectId, onClose, permissions, initialSelectedFile, onInitialFileSelected }) => {
  const [selectedFile, setSelectedFile] = useState<FileNode | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const hasUpdatePermission = permissions?.includes(Permissions.UpdateProjectPermission);

  const handleFileSelect = (file: FileNode) => {
    setSelectedFile(file);
  };

  const handlePanelClose = () => {
    // Close button always closes the entire panel
    onClose();
  };

  const handleFileSave = () => {
    // Trigger refresh of file explorer after save
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div className="flex flex-row h-full w-full overflow-hidden bg-bg-primary">
      {/* File Explorer - Left Side */}
      <FileExplorer
        projectId={projectId}
        onFileSelect={handleFileSelect}
        selectedFile={selectedFile?.path}
        refreshTrigger={refreshTrigger}
        initialSelectedFile={initialSelectedFile}
        onInitialFileSelected={onInitialFileSelected}
      />

      {/* Code Editor - Right Side */}
      <CodeEditor
        file={selectedFile}
        projectId={projectId}
        onFileSave={handleFileSave}
        onFileClose={handlePanelClose}
        readOnly={!hasUpdatePermission}
      />
    </div>
  );
};

export default CodebasePanel;

